<template lang='pug'>
div.title-bar-content-container
  v-toolbar(v-if="showAppBar" color="primary" flat)
    v-avatar.mr-4(size='36')
      img(v-if='avatarUrl' :src='avatarUrl')
      img(v-else src='/quickytools.svg')
    v-toolbar-title.h6-material.quickytools-font {{ day6Resource.appTitle }}
    v-spacer
    AccountPaidStatus(@open-account-pay="openAccountPay")
    AccountOptionsBar.ml-4
  router-view.flex-grow-1
</template>

<script>
import appRoute from '@/router/routes'
import day6Resource from '@/resources/day6'
import day6Store from '../../store/modules/day6'
import day6CharacterBrowserStore from '../../store/modules/day6CharacterBrowser'
import AccountOptionsBar from '../account/account-options-bar.vue'
import AccountPaidStatus from '../account/account-paid-status'
import analyticsMixin from './editor-mixins/AnalyticsMixin'

const day6Route = appRoute.day6
const { isCharacterPath } = day6Route

export default {
  name: 'Day6',
  components: { AccountPaidStatus, AccountOptionsBar },
  mixins: [
    analyticsMixin
  ],
  data: function () {
    return {
      day6Resource,
      showAppBar: this.isAppBarVisible(this.$vuetify),
      showBackNavigation: false
    }
  },
  computed: {
    avatarUrl () {
      return this.$store.getters.accountPictureUrl
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (isCharacterPath(from.path) && isCharacterPath(to.path)) {
      this.appEventBus.$emit('day6-navigate',
        {
          from: from.path,
          to: to.path
        })
    }

    this.showBackNavigation = day6Route.isNestedPath(to)
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (isCharacterPath(from.path) && !isCharacterPath(to.path)) {
      this.appEventBus.$emit('leave-day6', { next })
    } else {
      next()
    }
  },
  created () {
    this.$store.registerModule('day6', day6Store)
    this.$store.registerModule('day6CharacterBrowser', day6CharacterBrowserStore)
  },
  beforeDestroy () {
    this.$store.unregisterModule('day6', day6Store)
    this.$store.unregisterModule('day6CharacterBrowser', day6CharacterBrowserStore)
  },
  methods: {
    openAccountPay () {
      this.$router.push({ name: 'account-pay' })

      this.captureOpenAccount(true)
    }
  }
}
</script>
